import React from 'react';

interface IconTrendProps {
    iconClasses?: string;
}

const IconTrend: React.FC<IconTrendProps> = ({ iconClasses }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-trend ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M1.5 11.5 5.2 7.8 8.1 10.7 14.5 4.3"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 4.3h4v4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconTrend;
